export const TOOL_URL = "/tool";
export const LOGIN_PATH = "login";
export const LOGIN_URL = `${TOOL_URL}/${LOGIN_PATH}`;

export const TESTS_PATH = "tests";
export const TESTS_URL = `${TOOL_URL}/${TESTS_PATH}`;
export const ADD_TEST_URL = `${TESTS_URL}/new`;

export const ENTRIES_PATH = "entries";
export const ENTRIES_URL = `${TOOL_URL}/${ENTRIES_PATH}`;

export const REPORT_PATH = "reports";
export const REPORT_URL = `${TOOL_URL}/${REPORT_PATH}`;
export const ADD_REPORT_URL = `${REPORT_URL}/new`;

export const GROUP_PATH = "groups";
export const GROUP_URL = `${TOOL_URL}/${GROUP_PATH}`;
export const ADD_GROUP_URL = `${GROUP_URL}/new`;

export const CLIENTS_PATH = "clients";
export const CLIENTS_URL = `${TOOL_URL}/${CLIENTS_PATH}`;
export const ADD_CLIENT_URL = `${CLIENTS_URL}/new`;

export const FILTER_BY_CLIENT = {
  [ENTRIES_URL]: true,
  [TESTS_URL]: true,
  [REPORT_URL]: true,
  [GROUP_URL]: true,
};

export function initiateClientsMap(t) {
  return new Map([
    [undefined, t("tool.clientSelector.all", "All clients")],
    ["null", t("tool.clientSelector.none", "No client")],
  ]);
}
